
let _tencent = {

    //加载基础代码 - 密钥
    load: function(key){
        let js = '!function(g, d, t, e, v, n, s) {\n' +
            '        if (g.gdt) return;\n' +
            '        v = g.gdt = function() {\n' +
            '            v.tk ? v.tk.apply(v, arguments) : v.queue.push(arguments)\n' +
            '        };\n' +
            '        v.sv = \'1.0\';\n' +
            '        v.bt = 0;\n' +
            '        v.queue = [];\n' +
            '        n = d.createElement(t);\n' +
            '        n.async = !0;\n' +
            '        n.src = e;\n' +
            '        s = d.getElementsByTagName(t)[0];\n' +
            '        s.parentNode.insertBefore(n, s);\n' +
            '    }(window, document, \'script\', \'//qzonestyle.gtimg.cn/qzone/biz/gdt/dmp/user-action/gdtevent.min.js\');\n' +
            '    gdt(\'init\', ' + key + ');\n' +
            'gdt(\'track\', \'PAGE_VIEW\')';

        let _head = document.getElementsByTagName("head")[0];
        let script = document.createElement("script");
        script.append(js);
        _head.appendChild(script);
    },

    //加载事件代码
    submit: function () {
        try {
            gdt('track', 'RESERVATION', {'key1': 'value1', 'key2': 'value2'});
        } catch (e) {
            console.log(e)
        }
    },
};

export default _tencent
